import {
  RECETADIGITAL_SUCCESS,
  RECETADIGITAL_LOADING,
  RECETADIGITAL_ERROR,
  RECETADIGITAL_RESET,
  RECETADIGITAL_SETERRORUSUARIO,
  RECETADIGITAL_SETRECETA,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

/* export const wsPostFormularioReceta = (formulario) => (dispatch) => {
  dispatch({
    type: RECETADIGITAL_LOADING,
  });

  axiosInstance().then((respuesta) => {
    respuesta
      .post("/ordenmedica", formulario)
      .then((res) => {
        dispatch({
          type: RECETADIGITAL_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: RECETADIGITAL_ERROR,
          payload: error,
        });
      });
  });
}; */
export const wsPostFormularioReceta = (formulario) => (dispatch) => {
  dispatch({
    type: RECETADIGITAL_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .post("his/turnos/orden-medica", formulario)
      .then((res) => {
        dispatch({
          type: RECETADIGITAL_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: RECETADIGITAL_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetMisRecetas =
  (idPacFamiliar, dniPac, filtroFecha, nextStep) => (dispatch) => {
    dispatch({ type: RECETADIGITAL_LOADING });
    axiosLogin().then((respuesta) => {
      respuesta
        .get(
          `his/recetas/${
            !idPacFamiliar ? -1 : idPacFamiliar
          }/${dniPac}/${filtroFecha}`
        )
        .then((resp) => {
          dispatch({
            type: RECETADIGITAL_SUCCESS,
            payload: resp.data,
          });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: RECETADIGITAL_ERROR, payload: err.response.data });
          if (nextStep) nextStep(false, err.response.data);
        });
    });
  };

export const recetasDigitalesReset = () => (dispatch) => {
  dispatch({
    type: RECETADIGITAL_RESET,
  });
};

export const setListErrorReceta = (listErrorReceta) => (dispatch) => {
  dispatch({
    type: RECETADIGITAL_SETERRORUSUARIO,
    payload: listErrorReceta,
  });
};

export const setReceta = (receta) => (dispatch) => {
  dispatch({
    type: RECETADIGITAL_SETRECETA,
    payload: receta,
  });
};
